module.exports = __webpack_public_path__ + "static/media/DSC_0859.8996ed34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0859.jpg
// module id = 604
// module chunks = 0